import { TurnType } from '@db8/shared'
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const turnTypeToArray = (type) => {
  if (type === TurnType.Affirmative) return 'globalGreenArg'
  else if (type === TurnType.Negative) return 'globalRedArg'
  else if (type === TurnType.AffirmativeCrossNegative) return 'greenCrossExamination'
  else if (type === TurnType.NegativeCrossAffirmative) return 'redCrossExamination'
}
